import * as PDFJS from 'pdfjs-dist'
PDFJS.GlobalWorkerOptions.workerSrc =
  'https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js'

export const PDFToImage = ({ blob, scale }) => {
  let pdf
  const getPage = (num) => {
    return new Promise((resolve, reject) => {
      pdf.getPage(num).then((page) => {
        if (typeof scale !== 'number' || isNaN(scale) || scale < 0) {
          scale = 1
        }
        const viewport = page.getViewport({ scale })
        const canvas = document.createElement('canvas')
        const canvasContext = canvas.getContext('2d')
        canvas.height = viewport.height
        canvas.width = viewport.width
        page
          .render({
            canvasContext,
            viewport
          })
          .promise.then(() => {
            resolve(canvas.toDataURL('image/jpeg'))
          })
          .catch((error) => {
            reject(error)
          })
      })
    })
  }

  return PDFJS.getDocument(blob)?.promise?.then((pdfx) => {
    const pages = []
    pdf = pdfx
    for (let i = 0; i < pdfx.numPages; i++) {
      pages.push(getPage(i + 1))
    }

    return Promise.all(pages)
      .then((imgPages) => {
        return imgPages
      })
      .catch(console.error)
  })
}
